import entityMappingService from "EntityMappingService";
import lookupMetadataFactory, {
  type LookupMetadata,
  type LookupMetadataFactoryArgs,
} from "Lookups/LookupMetadataFactory";
import ruleFunction from "RuleFunction";
import ruleRepository from "RuleRepository";
import type { QueryBasedLookupMetadataInfo, RuleBasedLookupMetadataInfo } from "RulesetMetadata";
import { isEmpty } from "lodash-es";

function getFactoryArgs(
  item: QueryBasedLookupMetadataInfo | RuleBasedLookupMetadataInfo,
): LookupMetadataFactoryArgs | undefined {
  if (!("itemType" in item)) {
    return { ...item };
  }

  if (!entityMappingService.hasInterfaceName(item.itemType)) {
    return undefined;
  }

  const { ensurePreconditions, filter, lookupFunc } = item;
  return {
    ...item,
    ensurePreconditions: ensurePreconditions ? ruleFunction(ensurePreconditions) : undefined,
    filter: typeof filter === "string" ? ruleFunction(filter) : filter,
    lookupFunc: lookupFunc ? ruleFunction(lookupFunc) : undefined,
  };
}

export default function lookupMetadataRulesBootstrapper(): void {
  ruleRepository.addRegistrar("lookupMetadata", (ruleSet) => {
    const lookupMetadata = ruleSet.lookupMetaData;
    if (lookupMetadata) {
      const result: Record<string, LookupMetadata> = {};
      for (const propertyName in lookupMetadata) {
        const item = lookupMetadata[propertyName];
        const args = getFactoryArgs(item);
        if (!args) {
          continue;
        }

        args.entityName = ruleSet.entityName;
        const metadata = lookupMetadataFactory.create(args);
        if (metadata) {
          result[propertyName] = metadata;
        }
      }

      if (!isEmpty(result)) {
        return result;
      }
    }

    return undefined;
  });
}
